"use client";

import React from "react";
import TopBar from "./TopBar";
import PromotionalHeader from "./PromotionalHeader";
import MainHeader from "./MainHeader";
import MenuHeader from "./MenuHeader";

interface HeaderV1Props {
  showTopBar?: number;
  showPromotional?: number;
}

export default function HeaderV1({
  showTopBar = 1,
  showPromotional = 0,
}: HeaderV1Props) {
  return (
    <header className="w-[100%]">
      {showTopBar === 1 && (
        <div className="hidden md:block">
          <TopBar />
        </div>
      )}

      {showPromotional === 1 && (
        <div className="hidden md:block">
          <PromotionalHeader />
        </div>
      )}

      <MainHeader />
      <MenuHeader />
    </header>
  );
}
